var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#054940"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 11.875C22.266 11.8782 19.6448 12.9658 17.7115 14.899C15.7783 16.8323 14.6907 19.4534 14.6875 22.1875C14.6842 24.4218 15.4141 26.5954 16.765 28.375C16.765 28.375 17.0463 28.7453 17.0922 28.7987L25 38.125L32.9116 28.7941C32.9528 28.7444 33.235 28.375 33.235 28.375L33.2359 28.3722C34.5862 26.5934 35.3157 24.4207 35.3125 22.1875C35.3093 19.4534 34.2218 16.8323 32.2885 14.899C30.3552 12.9658 27.7341 11.8782 25 11.875ZM25 25.9375C24.2583 25.9375 23.5333 25.7176 22.9166 25.3055C22.2999 24.8935 21.8193 24.3078 21.5355 23.6226C21.2516 22.9373 21.1774 22.1833 21.3221 21.4559C21.4668 20.7285 21.8239 20.0603 22.3484 19.5358C22.8728 19.0114 23.541 18.6542 24.2684 18.5096C24.9959 18.3649 25.7499 18.4391 26.4351 18.723C27.1203 19.0068 27.706 19.4874 28.118 20.1041C28.5301 20.7208 28.75 21.4458 28.75 22.1875C28.7488 23.1817 28.3533 24.1348 27.6503 24.8378C26.9473 25.5408 25.9942 25.9363 25 25.9375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.882d99d36049e8146e272922852b21bd.svg";
export { ForwardRef as ReactComponent };